/**
 * Idle shift auto-close hours, as typed (OPEN-110, Corbin) — pure, unit-tested.
 *
 * A driver's shift with no activity (no clock event, job event or GPS point) for this many
 * hours is closed automatically, backdated to the last activity. Whole hours 4–16; the API
 * refuses anything else with 400 VALIDATION_FAILED, so the box refuses it first.
 */

export const IDLE_CLOSE_HOURS_MIN = 4;
export const IDLE_CLOSE_HOURS_MAX = 16;
export const IDLE_CLOSE_HOURS_DEFAULT = 8;

export type IdleHoursParse =
  | { readonly ok: true; readonly hours: number }
  | { readonly ok: false; readonly message: string };

export function parseIdleHours(raw: string): IdleHoursParse {
  const t = raw.trim();
  const message = `Enter a whole number of hours from ${String(IDLE_CLOSE_HOURS_MIN)} to ${String(IDLE_CLOSE_HOURS_MAX)}.`;
  if (!/^\d{1,2}$/.test(t)) return { ok: false, message };
  const hours = Number(t);
  if (hours < IDLE_CLOSE_HOURS_MIN || hours > IDLE_CLOSE_HOURS_MAX) return { ok: false, message };
  return { ok: true, hours };
}
